import React from 'react';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import StepDataConditions from './StepDataConditions';
import StepDataExamples from './StepDataExamples';

const renderStepData = ({
  placement,
  type,
  onFullTextLinkClick,
  onIssueCitedCounterClick,
  onExperimentalProcedureOpen,
  onAbstractOpen,
  onAuthorClick,
  saveStepSelectionsHandler,
  loadLastExamples,
  ...stepData
}) => {
  switch (type) {
    case RouteType.PUBLISHED: {
      const { isLoading, data, step, selected, parentId } = stepData;
      return (
        <StepDataConditions
          isLoading={isLoading}
          data={data}
          isPublished
          onFullTextLinkClick={onFullTextLinkClick}
          onIssueCitedCounterClick={onIssueCitedCounterClick}
          onExperimentalProcedureOpen={onExperimentalProcedureOpen}
          onAbstractOpen={onAbstractOpen}
          onAuthorClick={onAuthorClick}
          saveStepSelectionsHandler={saveStepSelectionsHandler}
          stepId={step}
          viewSelected={selected}
          parentId={parentId}
        />
      );
    }
    case RouteType.PREDICTED: {
      const { isLoading, examples, firstPriorityData, lastPriorityData, step, selected } = stepData;
      return (
        <StepDataExamples
          isLoading={isLoading}
          examples={examples}
          placement={placement}
          isPredicted
          firstPriorityData={firstPriorityData}
          lastPriorityData={lastPriorityData}
          saveStepSelectionsHandler={saveStepSelectionsHandler}
          stepId={step}
          viewSelected={selected}
          loadLastExamples={loadLastExamples}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default renderStepData;
